import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";

import { leadershipData } from "../data/leadershipData";
import AnimatedPage from "../component/LeadershipComponents/AnimatedPage";
import SectionHeader from "../component/LeadershipComponents/SectionHeader";
import ProfileCard from "../component/LeadershipComponents/ProfileCard";
import Navbar from "../component/Navbar";
import Footer from "../component/Footer";
import HeadingWithWatermark from "../component/HeadingWithWatermark";

const Leadership = () => {
  const navigate = useNavigate();
  const chairmanRef = useRef(null);
  const isChairmanInView = useInView(chairmanRef, { once: true, amount: 0.3 });

  const handleCardClick = (id) => {
    navigate(`/leadership/${id}`);
  };
  
const handleChairmanClick = () => {
  navigate(`/leadership/${leadershipData.chairman.id}`);
};
  return (
    <>
    <Navbar/>
     <AnimatedPage>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 bg-white">
        {/* Chairman Section */}
        <section ref={chairmanRef} className="mb-24">
          <div className="bg-gradient-to-br from-blue-50 to-white rounded-3xl shadow-xl overflow-hidden border border-blue-100">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              {/* Image with animation */}
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                animate={isChairmanInView ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.8, ease: "easeOut" }}
                className="h-full"
              >
                <img
                  src={leadershipData.chairman.image}
                  alt={leadershipData.chairman.name}
                  className="w-full h-full object-cover object-center rounded-l-3xl"
                />
              </motion.div>

              {/* Quote with animation */}
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                animate={isChairmanInView ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
                className="p-12"
              >
                <h2 className="text-4xl font-bold text-blue-900 mb-6">
                  From the Chairman's Desk
                </h2>
                <p className="text-2xl text-gray-700 italic leading-relaxed"Z>
                  "{leadershipData.chairman.message}"
                </p>
                <p className="mt-6 text-xl font-semibold text-blue-800">
                  — {leadershipData.chairman.name}
                </p>
                <p className="text-blue-600">{leadershipData.chairman.designation}</p>
              <button
  onClick={handleChairmanClick}
  className="text-sm text-blue-600 font-medium mt-2 transition duration-300"
>
  View Profile →
</button>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Office Bearers Grid */}
        <section>
       
              <HeadingWithWatermark
          title="Office Bearers"
          watermarkText="WASME"
          color="#1b73a7"
          align="center"
        />
        <motion.div
  className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch"
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, amount: 0.2 }}
  variants={{
    visible: { transition: { staggerChildren: 0.15 } }
  }}
>
  {leadershipData.officeBearers.map((person) => (
    <motion.div
      key={person.id}
      variants={{
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0 }
      }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="h-full"
    >
      <ProfileCard
        person={person}
        onClick={handleCardClick}
      />
    </motion.div>
  ))}
</motion.div>
        </section>
      </div>
    </AnimatedPage>
    <Footer/>
    </>
    
   
  );
};

export default Leadership;